// Configuración central del wizard del modal

export const SECTIONS = [
    {
        id: 'vehicle',
        label: 'Vehículo',
        icon: 'Truck',
        description: 'Información del vehículo',
    },
    {
        id: 'driver',
        label: 'Chofer',
        icon: 'User',
        description: 'Datos del operador',
    },
    {
        id: 'technical',
        label: 'Diagnóstico',
        icon: 'Search',
        description: 'Análisis técnico',
    },
    {
        id: 'observations',
        label: 'Observaciones',
        icon: 'FileText',
        description: 'Notas adicionales',
    },
    {
        id: 'parts',
        label: 'Refacciones',
        icon: 'Package',
        description: 'Gestión de inventario',
    },
];

// Mapa para mandar al usuario a la sección correcta en caso de error
export const FIELD_SECTION_MAP = {
    workOrderNumber: 'vehicle',
    plates: 'vehicle',
    mileage: 'vehicle',
    client: 'vehicle',
    technicalDescription: 'technical',
};
